@if(showTable) {
<p-table #dataTable [globalFilterFields]="[
            'pbm_order_id', 
            'route_name',
            'bl_name', 
            'address',
            'postal_code',
            'task_point_name',
            'item_count',
            'delivery_point_area_name',
            'goods_count',
            'driver_instruction',
            'manager_instruction',
            'vehicle_type',
            'user_name',
            'source',
            'task_type',
            'task_state',
            'task_time_window'
        ]" [value]="unplannedData" columnResizeMode="expand"  [resizableColumns]="true" [columns]="visibleColumns" [selection]="taskMovementService.selectedOptionsForTaskMove" [rowHover]="true"
    [scrollable]="true" scrollHeight="flex" (onColResize)="saveColumnWidth($event)"
    [loading]="taskInfoService.loading" selectionMode="multiple" [metaKeySelection]="taskInfoService.metaKey"
    [multiSortMeta]="taskInfoService.multiSortMetaUPP" 
    [virtualScroll]="true"
    [virtualScrollItemSize]="32"
    (onHeaderCheckboxToggle)="onSelectAllToggle($event)"
    (selectionChange)="onSelectionChange($event)"
    [customSort]="isCustomSort"
    (onSort)="onColumnSort($event)"
    dataKey="task_id" sortMode="multiple"[tableStyle]="{'table-layout': 'fixed','width': '100%'}">
    <ng-template pTemplate="loadingicon">
        <svg id="ag-loading-overlay" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
            <circle class="circle" cx="12" cy="12" r="10" stroke-width="3" stroke="#3A5487"></circle>
            <circle class="dot" cx="21.3" cy="16" r="1.48" fill="#3A5487"></circle>
        </svg>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th style="width: 1.5rem" id="rowHighlight-header" [ngClass]="{'custom-sort-icon':taskInfoService.router.url != navigation.MapLeaflet, 'custom-sort-mapview':taskInfoService.router.url == navigation.MapLeaflet}">
                @if(taskMovementService.taskmoveCount()){
                    <div>
                        <img [src]="sortingService.isCustomSortApplied ? '../../../../../../assets/image/sort_selected.svg' : '../../../../../../assets/image/sort.svg'" (click)="setSelectedTaskSorting()"
                            class="icons-task-bank" onKeyDown="setSelectedTaskSorting()"
                            pTooltip="To sort by selected tasks" [hidden]="isSelectAll"/>
                    </div>
                }
            </th>
            <ng-container >
                <th id="rowHighlight-header" style="width: 2.5rem">S.No.
                </th>
            </ng-container>
            <th id="checkbox-header" style="width: 2.7rem;">
                @if (favList === "default" && (dataTable.filteredValue??unplannedData | selectionRowAllowed)) {
                    <p-tableHeaderCheckbox ></p-tableHeaderCheckbox>
                }
            </th>
            <th id="indicators-header" style="width: 3.5rem;">
                <i class="pi pi-flag"  pTooltip="Shipment Indicators"></i>
            </th>
            <ng-container *ngFor="let column of visibleColumns" >
                <th *ngIf="column.field !== 'task_time_window' && column.field !== 'task_state' && column.field !== 'pbm_order_id'" pResizableColumn  [ngStyle]="{width: column.width}"  [id]="column.field" scope="col" [pSortableColumn]="column.field">
                    {{column.label}}<p-sortIcon [field]="column.field" />
                </th>
                <th *ngIf="column.field === 'task_state'" pResizableColumn  [ngStyle]="{width: column.width}"  [id]="column.field" scope="col" [pSortableColumn]="column.field">
                    {{column.label}}
                    <p-sortIcon class="me-1" [field]="column.field" />
                    <p-columnFilter #statusColumnFilter field="task_state" matchMode="in" [showApplyButton]="false" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" [showClearButton]="false">
                        <ng-template pTemplate="filter" let-value let-filterCallback="filterCallback">
                            <p-multiSelect [ngModel]="value" [options]="statuses" placeholder="All" 
                            [maxSelectedLabels]="2"
                            optionValue="name"  [filter]="false" [showHeader]="false" [style]="{width:'100%'}"
                            (onChange)="onColumnFilterChange($event.value, filterCallback, columnFilterKeys.TaskStatus)" optionLabel="name">
                                <ng-template let-option pTemplate="item">
                                    <div class="flex align-items-center gap-2">
                                        <div>{{ option.name }}</div>
                                    </div>
                                </ng-template>
                            </p-multiSelect>
                              <button type="button" class="pn-button pn-button-primary mt-3 p-2 w-auto"
                                    (click)="onColumnFilterChange(null, filterCallback, columnFilterKeys.TaskStatus)">Clear</button>
                        </ng-template>
                    </p-columnFilter>
                </th>
                <th *ngIf="column.field === 'pbm_order_id'" pResizableColumn  [ngStyle]="{width: column.width}"  [id]="column.field" scope="col" [pSortableColumn]="column.field" >
                    {{column.label}}
                    <p-sortIcon class="me-1" [field]="column.field" />
                    <p-columnFilter #orderColumnFilter field="pbm_order_id" matchMode="startsWith" [showApplyButton]="false" display="menu" [showAddButton]="false" [showOperator]="false" [showMatchModes]="false" [showClearButton]="false">
                        <ng-template
                          pTemplate="filter"
                          let-value
                          let-filterCallback="filterCallback"
                        >
                          <p-select
                            [ngModel]="value"
                            [options]="pbmOrderType"
                            [style]="{width:'100%'}"
                            optionLabel="name" optionValue="value" 
                            (onChange)="onColumnFilterChange($event.value, filterCallback, columnFilterKeys.PbmOrderType)"
                            placeholder="All"
                          >
                            <ng-template let-option pTemplate="item">
                                <span>{{option.name}}</span>
                            </ng-template>
                          </p-select>
                          <button type="button" class="pn-button pn-button-primary mt-3 p-2 w-auto"
                            (click)="onColumnFilterChange(null, filterCallback, columnFilterKeys.PbmOrderType)">Clear</button>
                        </ng-template>
                      </p-columnFilter>
                </th>
                <th *ngIf="column.field === 'task_time_window'" pResizableColumn [ngStyle]="{'width': column.width}" scope="col" pSortableColumn="task_time_window">
                    {{column.label}}<p-sortIcon field="task_time_window" />
                </th>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-unplannedData let-rowIndex="rowIndex">
        <tr [pSelectableRowDisabled]="!unplannedData.isMovementAllowed"
            [pSelectableRow]="unplannedData.isMovementAllowed ? unplannedData : null" [pSelectableRowIndex]="rowIndex">
                <td id="rowHighlight-header" class="custom-sort-icon"></td>
            <ng-container >
                <td><span>{{unplannedData.index}}</span></td>
            </ng-container>
            <td>
                <ng-container *ngIf="unplannedData.isMovementAllowed; else showErrorMsg">
                    <p-tableCheckbox [pSelectableRow]="unplannedData" [value]="unplannedData"></p-tableCheckbox>
                </ng-container>
                <ng-template #showErrorMsg>
                    <i class="pi pi-info-circle info-icon" [pTooltip]="taskInfoService.taskMovementErrorMsg" appendTo="body" autoHide="false" tooltipStyleClass="taskmovement-error-tooltip"></i>
                </ng-template>
            </td>
            <td class="indicator-cell">
                <div class="indicator-rail">
                    @for(indicator of unplannedData?.indicators; track indicator.key; let i = $index) {
                        @if(i < 2) {
                            <img [src]="indicator.icon"
                                [pTooltip]="indicator.label"
                                tooltipPosition="bottom"
                                class="indicator-icon"
                                width="16" height="16"
                                [alt]="indicator.label" />
                        }
                    }
                    @if(unplannedData?.indicators?.length > 2) {
                        <span class="indicator-overflow"
                            (click)="showIndicatorPanel($event, unplannedData); $event.stopPropagation()">
                            +{{unplannedData.indicators.length - 2}}
                        </span>
                    }
                </div>
            </td>
            
            <ng-container  *ngFor="let col of visibleColumns">
                <td *ngIf="col.field !== 'task_state' && 
                    col.field !== 'pbm_order_id' && 
                    col.field !== 'item_count' && 
                    col.field !== 'goods_count' && 
                    col.field !== 'task_time_window' && 
                    col.field !== 'address' &&
                    col.field !== 'manager_instruction'"  
                    class="wrapRowData"
                    [pTooltip]="unplannedData[col.field]" tooltipPosition="bottom" >
                    {{unplannedData[col.field]}}
                </td>
                <td *ngIf="col.field === 'task_state'"><span [ngStyle]="unplannedData.task_state | TaskState">{{unplannedData.task_state}}</span></td>
                <td *ngIf="col.field === 'pbm_order_id'">
                    <div class="d-flex align-items-center">
                        <!--commented out this code for future use-->
                        <!-- @if(unplannedData.label_less_pickup) {
                            <img src="assets/image/label_less_pickup.png" 
                            pTooltip="Label Less Pickup" class="align-middle label-less-icon" width="13" height="13" alt="label_less_pickup" />
                        } -->
                        <i class="pi pi-search glass-icon" (click)="PBMlookup(unplannedData.pbm_order_id);$event.stopPropagation()" 
                        pTooltip="Open PBM Lookup" style="margin-right: .2rem; font-size: .6rem;"></i>
                        <a class="anchor"  
                         [style.--orderColor]="unplannedData?.pbm_order_id | orderIdColor : unplannedData?.external_keys?.is_swedish_election_order"
                        (click)="taskInfoService.editPickupOrder(unplannedData);$event.stopPropagation()"
                        onkeydown="taskInfoService.editPickupOrder(unplannedData);$event.stopPropagation()">{{unplannedData.pbm_order_id}}</a>
                    </div>    
                </td>
                <td *ngIf="col.field === 'address'"class="wrapRowData" [pTooltip]="unplannedData.address" tooltipPosition="bottom">
                    <button (click)="taskInfoService.showDialog(unplannedData , 'address', 'TaskBank'); $event.stopPropagation();"
                        class="pi pi-pencil edit-icon"></button>
                    {{unplannedData.address}}
                </td>
                <td *ngIf="col.field === 'manager_instruction'" class="wrapRowData" [pTooltip]="unplannedData.manager_instruction" tooltipPosition="bottom">
                   <button (click)="taskInfoService.showDialog(unplannedData , 'manager', 'TaskBank') ; $event.stopPropagation();" class="pi pi-pencil edit-icon"></button>
                   {{unplannedData.manager_instruction}}
                </td>

                <td *ngIf="col.field === 'item_count'" [ngClass]="{'pointer-cursor': unplannedData.item_count > 0}"
                    onkeydown="openItemDialog(unplannedData, 'items'); $event.stopPropagation();" (click)="openItemDialog(unplannedData, 'items'); $event.stopPropagation();">
                    <a class="anchor" *ngIf="unplannedData.item_count > 0">{{unplannedData.item_count}}</a>
                    <span *ngIf="unplannedData.item_count === 0">{{unplannedData.item_count}}</span>
                </td>
                <td  *ngIf="col.field === 'goods_count'" [pTooltip]="unplannedData.good_types" tooltipPosition="bottom" [ngClass]="{'pointer-cursor': unplannedData.goods_count > 0}"
                    onkeydown="openItemDialog(unplannedData, 'goods'); $event.stopPropagation();" (click)="openItemDialog(unplannedData, 'goods'); $event.stopPropagation();">
                    <a class="anchor" *ngIf="unplannedData.goods_count > 0">{{unplannedData.goods_count}}</a>
                    <span *ngIf="unplannedData.goods_count === 0">{{unplannedData.goods_count}}</span>
                </td>
                <td *ngIf="col.field === 'task_time_window'" >{{unplannedData.task_time_window}}</td>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="visibleColumns.length + 4">
                <div class="text-center no-record-label">
                    No Records found.
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>
}
<div class="taskBankSummary">
    <div>Total <b>{{unplannedData.length}}</b> Tasks</div>

    @if(taskMovementService.taskmoveCount()){
        <img [src]="taskMovementService.showSelectedTaskKPI ? '../../../../../../assets/image/flip_icon_selected.svg' : '../../../../../../assets/image/flip_icon.svg'"
            (click)="taskMovementService.toggleIconRotation()"
            class="icons-task-bank"/>
    }

    @if(taskMovementService.taskmoveCount() && !taskMovementService.showSelectedTaskKPI){
        <div>
            <p-tag value="{{taskMovementService.taskmoveCount()}} {{taskMovementService.taskmoveCount() == 1 ? 'task' : 'tasks'}} selected" 
            class="primary-chip"/>
        </div>
        @for(kpi of taskMovementService.selectedTaskKPI; track kpi){
            @if(kpi.key===selectedTBRowKPIGroups.TaskType){
            <div class="kpi-footer-props" [pTooltip]="kpi.value.toString()" tooltipPosition="top">{{kpi.key | removeUnderscore | titlecase }} : <b>{{kpi.value}}</b></div>
            }
            @else {
            <div>{{kpi.key | removeUnderscore | titlecase }} : <b>{{kpi.value}}</b>
            </div>
            }

        }
    }
    @else {
        <div><b>{{ unplannedData | taskskpicountPipe : taskState.Unplanned }}</b> Unplanned</div>
        <div><b>{{ unplannedData | taskskpicountPipe : taskState.Cancelled }}</b> Cancelled</div>
        <div><b>{{ unplannedData | taskskpicountPipe : taskState.Rejected }}</b> Rejected</div>
        <div><b>{{ unplannedData | taskskpicountPipe : taskState.Notacted}}</b> Not Acted</div>
        <div><b>{{ unplannedData | taskskpicountPipe : taskType.Pickup}}</b> Pickup</div>
        <div><b>{{ unplannedData | taskskpicountPipe : taskType.Myboxpickup}}</b> MyBoxpickup</div>
        <app-color-legends [colorlegends]="tbLegends"></app-color-legends>
    }
</div>
<p-dialog header="{{header}}" [(visible)]="displayItemDialog" [modal]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '80vw' }" [draggable]="false"
    [resizable]="false">
    <app-item-details *ngIf="displayItemDialog" [additionalData]="additionalData"></app-item-details>
</p-dialog>

@if(DialogType === 'TaskBank' && getShowPopup) {
    
    <p-dialog header="{{ taskInfoService.updatePopup.dialogHeader }}" [(visible)]="getShowPopup"
            [modal]="true"  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
            [style]="{width: taskInfoService.updatePopup.dialogHeader === 'Update Address' ? '70vw' : '40vw'}"
            [draggable]="false"
            [resizable]="false"
            (onHide)="closeDialog(true)">
    
    @if (taskInfoService.updatePopup.dialogHeader === 'Update Address') {
        <app-update-address
        (onCancel)="closeDialog($event)"
        #updateStateAddressUnplanned
        [taskId]="taskInfoService.updatePopup.updateTask.task_id"
        (closeDialog)="closeDialog($event); refreshActiveTabData()">
        </app-update-address>
        <ng-template #footer>
            <ng-container *ngTemplateOutlet="updateStateAddressUnplanned.updateAddressFooter"></ng-container>
        </ng-template>
    }
    @else if (taskInfoService.updatePopup.dialogHeader === 'Update Manager Notes') {
        <app-update-manager-notes
        #managerNotesFooter
        [task]="taskInfoService.updatePopup.updateTask"
        (closeDialog)="closeDialog($event); refreshActiveTabData()">
        </app-update-manager-notes>
        <ng-template #footer>
            <ng-container *ngTemplateOutlet="managerNotesFooter.managerNotesFooter"></ng-container>
        </ng-template>
    }
    
    </p-dialog>
}
<p-popover #indicatorPanel [dismissable]="true" [style]="{width: '220px'}">
    <div class="indicator-panel-list">
        @for(indicator of activeIndicators; track indicator.key) {
            <div class="indicator-panel-row">
                <img [src]="indicator.icon" width="16" height="16" [alt]="indicator.label" />
                <span>{{indicator.label}}</span>
            </div>
        }
    </div>
</p-popover>
